export enum EnumTipoTaxa {
    CUSTO = 0,
    VENDA = 1
}